import { Avatar, Button } from '@mui/material'
import React, { useEffect, useState } from 'react'
import LocationOnIcon from '@mui/icons-material/LocationOn'
import FeaturedServiceCard from './Cards/FeaturedServiceCard'
import EditProfileDetailsIcon from '../assets/imgs/profile-screen-images/edit-profile-icon.svg'
import StarIcon from '../assets/imgs/star-icon.svg'
import ChevronRightIcon from '@mui/icons-material/ChevronRight'
import EditProfileDetails from '../modals/EditProfileDetails'
import NotificationsModal from '../modals/NotificationsModal'
import PromotionModal from '../modals/PromotionModal'
import DirectDepositModal from '../modals/DirectDepositModal'
import { Link, useNavigate } from 'react-router-dom'
import EditIconWhite from '../assets/imgs/profile-screen-images/edit-icon-white.svg'
import UserImagePlaceHolder from '../assets/imgs/user-image-placeholder.png'
import EditPhotosModal from '../modals/EditPhotosModal'
import ClosingMessageModal from '../modals/ClosingMessageModal'
import AboutMeModal from '../modals/AboutMe'
import AccountSettingsModal from '../modals/AccountSettingsModal'
import SupportModal from '../modals/SupportModal'
import LocationModal from '../modals/LocationModal'
import AddOrEditSkillsModal from '../modals/AddOrEditSkillsModal'
import SelectWorkAreaModal from '../modals/SelectWorkAreaModal'
import ClientServices from '../Client/Components/ClientServices'
import ChangePasswordModal from '../modals/ChangePasswordModal'
import PaymentModal from '../modals/PaymentModal'
import { useSelector } from 'react-redux'
import { logout, selectUser } from '../app/features/user/userSlice'
import { getDataById, updateDataById } from '../apis/generalApis'
import { useDispatch } from 'react-redux'
import { setPortfolio } from '../app/features/portolioSlice'
import CreateServiceModal from '../modals/CreateServiceModal'
import { ScaleLoader } from 'react-spinners'

const EditProfile = () => {
  const ssUser = JSON.parse(localStorage.getItem('user'))
  const [user, setUser] = useState(ssUser)
  const [isLoading, setIsLoading] = useState(false)
  const [userBusinessImages, setUserBusinessImages] = useState([])
  const [stylistServices, setStylistServices] = useState([])
  const [stylistProfile, setStylistProfile] = useState(null)
  useEffect(() => {
    getUserSkills()
    getPortfolioImages()
    getStylistServices()
    getStylistProfile()
  }, [])

  const getStylistProfile = async () => {
    let body = {
      user_id: user?.id,
      viewer_id: user?.id,
    }
    // if (id) {
    //   body.user_id = Number(id)
    //   body.viewer_id = user?.id
    // }
    setIsLoading(true)
    let result = await getDataById('show-stylist-profile', body)
    setIsLoading(false)
    if (result?.success === true && result?.data != null) {
      // dispatch(setStylistProfile({ stylistProfile: result?.data }))
      setStylistProfile(result?.data)
    }
  }

  const getStylistServices = async () => {
    const body = {
      stylist_id: user?.id,
    }
    setIsLoading(true)
    const result = await getDataById('stylist-services', body)
    setIsLoading(false)
    if (result?.success === true && result?.data) {
      setStylistServices(result?.data)
    }
  }

  const dispatch = useDispatch()

  const getUserSkills = async () => {
    let body = {
      stylist_id: user?.id,
    }
    setIsLoading(true)
    let result = await getDataById('stylist-services', body)
    setIsLoading(false)
    if (result.success === true && result.data) {
    }
  }

  const getPortfolioImages = async () => {
    let body = {
      user_id: user?.id,
    }
    setIsLoading(true)
    let result = await getDataById('show-portfolio', body)
    setIsLoading(false)
    if (result?.data != null) {
      dispatch(setPortfolio({ data: result?.data }))
      setUserBusinessImages(result?.data)
    }
  }

  const navigate = useNavigate()
  const [
    editProfileDetailsModalOpen,
    setEditProfileDetailsModalOpen,
  ] = useState(false)
  const [selectedService, setSelectedService] = useState(null)
  const [notificationsModalOpen, setNotificationsModalOpen] = useState(false)
  // const [promotionModalOpen, setPromotionModalOpen] = useState(false)
  const [directDepositModalOpen, setDirectDepositModalOpen] = useState(false)
  const [openEditPhotosModal, setOpenEditPhotosModal] = useState(false)
  const [closingMessageModal, setClosingMessageModal] = useState(false)
  const [aboutMeModal, setAboutMeModal] = useState(false)
  const [accountSettingsModal, setAccountSettingsModal] = useState(false)
  const [supportModal, setSupportModal] = useState(false)
  const [locationModal, setLocationModal] = React.useState(false)
  const [addOrEditSkillsModal, setAddOrEditSkillsModal] = useState(false)
  const [selectWorkAreaModal, setSelectWorkAreaModalOptions] = useState(false)
  const [changePasswordModal, setChangePasswordModal] = React.useState(false)
  const [togglePaymentModal, setTogglePaymentModal] = React.useState(false)
  const [createServiceModal, setCreateServiceModal] = React.useState(false)

  const toggleEditProfileDetailsModal = () => {
    setEditProfileDetailsModalOpen(!editProfileDetailsModalOpen)
  }
  const toggleNotificationsModal = () => {
    setNotificationsModalOpen(!notificationsModalOpen)
  }
  // const togglePromotionModal = () => {
  //   setPromotionModalOpen(!promotionModalOpen)
  // }
  const toggleDirectDepositModal = () => {
    setDirectDepositModalOpen(!directDepositModalOpen)
  }
  const handleEditPhotosModal = () => {
    setOpenEditPhotosModal(!openEditPhotosModal)
  }
  const handleClosingMessageModal = () => {
    setClosingMessageModal(!closingMessageModal)
  }
  const handleAboutMeModal = () => {
    setAboutMeModal(!aboutMeModal)
  }
  const handleAccountSettingsModal = () => {
    setAccountSettingsModal(!accountSettingsModal)
  }
  const handleSupportModal = () => {
    setSupportModal(!supportModal)
  }
  const handleLocationModal = () => {
    setLocationModal(!locationModal)
  }
  const handleAddOrEditSkillsModal = () => {
    setAddOrEditSkillsModal((prev) => !prev)
  }
  const handleCreateServiceModal = (service) => {
    // handleAddOrEditSkillsModal()
    if (addOrEditSkillsModal === true) {
      setAddOrEditSkillsModal(false)
    }
    setSelectedService(service)
    setCreateServiceModal((prev) => !prev)
  }
  const handleSelectWorkAreaModal = () => {
    setSelectWorkAreaModalOptions(!selectWorkAreaModal)
  }
  const handleChangePasswordModal = () => {
    setChangePasswordModal(!changePasswordModal)
  }
  const handlePaymentModal = () => {
    setTogglePaymentModal(!togglePaymentModal)
  }
  const logoutUser = async () => {
    setIsLoading(true)
    let response = await updateDataById('user-logout', { user_id: user?.id })
    setIsLoading(false)
    if (response?.success === true) {
      localStorage.clear()
      navigate('/login')
    }
  }

  return (
    <div className="edit-profile px-3">
      <ScaleLoader
        color="#36d7b7"
        loading={isLoading}
        size={200}
        style={{
          position: 'fixed',
          left: 0,
          right: 0,
          height: '100%',
          top: 0,
          display: 'flex',
          zIndex: 9,
          justifyContent: 'center',
          alignItems: 'center',
          backdropFilter: 'blur(10px)',
          background: '#ffffff00 0% 0% no-repeat padding-box',
        }}
      />
      <div className="row" style={{ height: 'calc(100vh - 90px)' }}>
        <div className="col-12 col-sm-12 col-md-4 h-100">
          <div
            className={
              user?.user_type === 'client'
                ? `user-details p-4 h-100 overflow-auto border-0`
                : `user-details p-4 h-100 overflow-auto`
            }
          >
            <div className="row">
              <div className="col-12 col-sm-4 col-md-12">
                <div className="text-center position-relative h-100 d-flex align-items-center justify-content-center">
                  {user?.profile_image && (
                    <Avatar
                      src={user?.profile_image}
                      sx={{ height: 137, width: 137 }}
                    />
                  )}
                  {!user?.profile_image && (
                    <Avatar
                      src={UserImagePlaceHolder}
                      sx={{ height: 137, width: 137 }}
                    />
                  )}
                  <img
                    src={EditProfileDetailsIcon}
                    alt=""
                    height={35}
                    className="position-absolute pointer"
                    style={{ right: 0, top: 0 }}
                    onClick={toggleEditProfileDetailsModal}
                  />
                </div>
              </div>
              <div className="col-12 col-sm-8 col-md-12">
                <div className="user-info text-white mt-3 pt-2 pb-3 px-3">
                  <div className="text-center">
                    <p className="fs-24 m-0 font-weight-bold">{user?.name}</p>
                    <p className="fs-18 text-capitalize">
                      {stylistProfile?.title}
                    </p>
                    <p className="fs-14 d-inline-block m-0">
                      <img src={StarIcon} className="mb-1" alt="Star Icon" />
                      {Number(stylistProfile?.avg_rating).toFixed(2)}
                    </p>
                  </div>
                  <div className="d-flex justify-content-between align-items-center">
                    <div className="text-center">
                      <p className="m-0 fs-4">
                        {stylistProfile?.schedule_bookings?.length}
                      </p>
                      <p className="m-0">Scheduled</p>
                      <p className="m-0">Service</p>
                    </div>
                    <div className="text-center">
                      <p className="m-0 fs-4">
                        {stylistProfile?.completed_jobs}
                      </p>
                      <p className="m-0">Services</p>
                      <p className="m-0">Used</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="mt-4 px-3">
              <p className="fs-16 m-0 font-weight-bold mb-1">Account</p>
              <div className="d-flex fs-14 justify-content-between align-items-center">
                <p className="m-0">Email</p>
                <p className="m-0">{user?.email}</p>
              </div>
              <div className="d-flex fs-14 justify-content-between align-items-center">
                <p className="m-0">Phone</p>
                <p className="m-0">{user?.phone_number}</p>
              </div>
              <div className="d-flex fs-14 justify-content-between align-items-center">
                <p className="m-0 text-capitalize">ZIP</p>
                <p className="m-0">{user?.zip_code}</p>
              </div>
              <div className="d-flex fs-14 justify-content-between align-items-center">
                <p className="m-0">Country</p>
                <p className="m-0">{user?.country}</p>
              </div>
            </div>
            {user?.user_type != 'client' && (
              <div className="about-profile px-3 mt-3">
                <p className="fs-12 font-weight-bold">About</p>
                <p className="fs-15" style={{ wordBreak: 'break-all' }}>
                  {user?.about}
                </p>
              </div>
            )}
            <div className="mt-4 user-detail-modals">
              {user?.user_type != 'client' && (
                <div
                  className="d-flex justify-content-between align-items-center px-3 py-2 pointer"
                  onClick={handleClosingMessageModal}
                >
                  <p className="fs-16 font-weight-bold m-0">Closing Message</p>
                  <ChevronRightIcon />
                </div>
              )}
              {user?.user_type == 'client' && (
                <div>
                  <div
                    className="d-flex justify-content-between align-items-center px-3 py-2 pointer"
                    onClick={handleChangePasswordModal}
                  >
                    <p className="fs-16 font-weight-bold m-0">
                      Change Password
                    </p>
                    <ChevronRightIcon />
                  </div>
                  <div
                    className="d-flex justify-content-between align-items-center px-3 py-2 pointer"
                    onClick={handlePaymentModal}
                  >
                    <p className="fs-16 font-weight-bold m-0">Payment</p>
                    <ChevronRightIcon />
                  </div>
                </div>
              )}
              {user?.user_type != 'client' && (
                <div
                  className="d-flex justify-content-between align-items-center px-3 py-2 pointer"
                  onClick={toggleDirectDepositModal}
                >
                  <p className="fs-16 font-weight-bold m-0">Direct Deposit</p>
                  <ChevronRightIcon />
                </div>
              )}
              {/* <div
                className="d-flex justify-content-between align-items-center px-3 py-2 pointer"
                onClick={handleLocationModal}
              >
                <p className="fs-16 font-weight-bold m-0">Location</p>
                <ChevronRightIcon />
              </div> */}
              {/* <div
                className="d-flex justify-content-between pointer align-items-center px-3 py-2"
                onClick={togglePromotionModal}
              >
                <p className="fs-16 font-weight-bold m-0">
                  {user?.user_type === 'client' ? 'Promo' : 'Promotion'}
                </p>
                <ChevronRightIcon />
              </div> */}
              <div
                className="d-flex justify-content-between align-items-center px-3 py-2 pointer"
                onClick={toggleNotificationsModal}
              >
                <p className="fs-16 font-weight-bold m-0">Notifications</p>
                <ChevronRightIcon />
              </div>
              {user?.user_type != 'client' && (
                <div
                  className="d-flex justify-content-between align-items-center px-3 py-2 pointer"
                  onClick={handleAccountSettingsModal}
                >
                  <p className="fs-16 font-weight-bold m-0">Account Settings</p>
                  <ChevronRightIcon />
                </div>
              )}
              <div
                className="d-flex justify-content-between align-items-center px-3 py-2 pointer"
                onClick={handleSupportModal}
              >
                <p className="fs-16 font-weight-bold m-0">Support</p>
                <ChevronRightIcon />
              </div>
              {user?.user_type != 'client' && (
                <div
                  className="d-flex justify-content-between align-items-center px-3 py-2 pointer"
                  onClick={handleAboutMeModal}
                >
                  <p className="fs-16 font-weight-bold m-0">About Me</p>
                  <ChevronRightIcon />
                </div>
              )}
              {/* <Link to={'/login'} className="text-decoration-none"> */}
              <div
                className="d-flex justify-content-between align-items-center px-3 py-2 pointer"
                onClick={logoutUser}
              >
                <p className="fs-16 font-weight-bold m-0 text-danger">Logout</p>
                <ChevronRightIcon style={{ color: '#000' }} />
              </div>
              {/* </Link> */}
            </div>
          </div>
        </div>
        {user?.user_type !== 'client' && (
          <div className="col-12 col-sm-12 col-md-8">
            <div className="d-flex justify-content-between align-items-center mt-4 flex-wrap gap-3">
              <Button
                variant="contained"
                disableElevation
                onClick={handleSelectWorkAreaModal}
                className="edit-work-area btn fs-12 pointer text-capitalize"
                startIcon={
                  <img
                    src={EditIconWhite}
                    alt="Edit Icon"
                    height={16}
                    style={{ marginLeft: '1rem', marginRight: '2rem' }}
                  />
                }
                style={{ paddingRight: '4rem' }}
              >
                Edit Work Area
              </Button>
            </div>
            <div className="d-flex justify-content-between align-items-center my-4">
              <p className="fs-20 m-0 fw-bold">Services</p>
              <p
                className="fs-16 m-0 pointer fw-bold"
                onClick={() => {
                  setAddOrEditSkillsModal(true)
                }}
              >
                Create or Edit Services
              </p>
            </div>
            <div className="row py-1 flex-nowrap overflow-auto">
              {stylistServices.length > 0 &&
                stylistServices?.map((service) => (
                  <div
                    className="col-12 col-sm-6 col-md-6 col-lg-4"
                    key={service?.id}
                  >
                    <div
                      className="service-card-wrapper pointer"
                      onClick={() => handleCreateServiceModal(service)}
                    >
                      <FeaturedServiceCard service={service} />
                    </div>
                  </div>
                ))}
              {/* <div className="col-12 col-sm-6 col-md-6 col-lg-4">
                <div
                  className="service-card-wrapper pointer"
                  onClick={handleCreateServiceModal}
                >
                  <FeaturedServiceCard />
                </div>
              </div>
              <div className="col-12 col-sm-6 col-md-6 col-lg-4 mt-0 mt-sm-4 mt-md-0">
                <div
                  className="service-card-wrapper pointer"
                  onClick={handleCreateServiceModal}
                >
                  <FeaturedServiceCard />
                </div>
              </div> */}
            </div>
          </div>
        )}
        {user?.user_type === 'client' && (
          <div className="col-12 col-sm-12 col-md-8">
            <ClientServices screen="edit-profile" />
          </div>
        )}
      </div>
      <EditProfileDetails
        handleEditProfileDetailsModal={toggleEditProfileDetailsModal}
        editProfileDetailsModalOpen={editProfileDetailsModalOpen}
        setUser={setUser}
        getStylistProfile={getStylistProfile}
      />
      <NotificationsModal
        hanldeNotificationModal={toggleNotificationsModal}
        notificationsModalOpen={notificationsModalOpen}
      />
      {/* <PromotionModal
        handlePromotionModal={togglePromotionModal}
        promotionModalOpen={promotionModalOpen}
      /> */}
      <DirectDepositModal
        handleDirectDepositModal={toggleDirectDepositModal}
        directDepositModalOpen={directDepositModalOpen}
      />
      <EditPhotosModal
        openEditPhotosModal={openEditPhotosModal}
        handleEditPhotosModal={handleEditPhotosModal}
        userPortfolio={userBusinessImages}
        getPortfolioImages={getPortfolioImages}
        setUser={setUser}
      />
      <ClosingMessageModal
        handleClosingMessageModal={handleClosingMessageModal}
        closingMessageModal={closingMessageModal}
      />
      <AboutMeModal
        handleAboutMeModal={handleAboutMeModal}
        aboutMeModal={aboutMeModal}
      />
      <AccountSettingsModal
        handleAccountSettingsModal={handleAccountSettingsModal}
        accountSettingsModal={accountSettingsModal}
      />
      <SupportModal
        handleSupportModal={handleSupportModal}
        supportModal={supportModal}
      />
      {/* <LocationModal
        handleLocationModal={handleLocationModal}
        locationModal={locationModal}
      /> */}
      <AddOrEditSkillsModal
        handleAddOrEditSkillsModal={handleAddOrEditSkillsModal}
        addOrEditSkillsModal={addOrEditSkillsModal}
        stylistSkills={stylistServices}
        setStylistServices={setStylistServices}
        getStylistServices={getStylistServices}
        handleUpdateService={handleCreateServiceModal}
      />
      <SelectWorkAreaModal
        handleSelectWorkAreaModal={handleSelectWorkAreaModal}
        selectWorkAreaModal={selectWorkAreaModal}
      />
      <ChangePasswordModal
        handleChangePasswordModal={handleChangePasswordModal}
        modalOpen={changePasswordModal}
      />
      <PaymentModal
        handlePaymentModal={handlePaymentModal}
        togglePaymentModal={togglePaymentModal}
      />
      <CreateServiceModal
        handleCreateServiceModal={handleCreateServiceModal}
        createServiceModal={createServiceModal}
        component="edit-profile"
        service={selectedService}
        isNewService={selectedService ? false : true}
        getStylistServices={getStylistServices}
      />
    </div>
  )
}

export default EditProfile
